// The session's tokens, in localStorage under a `sculpt.backoffice.` prefix (a plain browser tab: no Office
// partition, no cookie games — the add-in's tokenStore explains why it needs those; this app does not).
// Tokens ride `Authorization:` headers, never cookies. A memory copy covers a blocked localStorage.

export const TOKEN_KEYS = ['accessToken', 'tokenType', 'refreshToken'] as const;
export type TokenKey = (typeof TOKEN_KEYS)[number];

const PREFIX = 'sculpt.backoffice.';
const memory = new Map<TokenKey, string>();

function key(name: TokenKey): string {
  return PREFIX + name;
}

export function writeToken(name: TokenKey, value: string): void {
  memory.set(name, value);
  try {
    localStorage.setItem(key(name), value);
  } catch {
    /* storage blocked: memory keeps the value for this tab */
  }
}

export function readToken(name: TokenKey): string | null {
  try {
    const stored = localStorage.getItem(key(name));
    if (stored !== null) return stored;
  } catch {
    /* fall through to memory */
  }
  return memory.get(name) ?? null;
}

export function clearTokens(): void {
  for (const name of TOKEN_KEYS) {
    memory.delete(name);
    try {
      localStorage.removeItem(key(name));
    } catch {
      /* nothing to do */
    }
  }
}

export function hasSession(): boolean {
  return readToken('accessToken') !== null;
}
